import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactHookFormIntlNumberInput } from 'common/components/form';

import { handleOnBlurField } from '../../helpers';

const DealerFee = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    const name = 'parameters.dealer_fee';
    return (
        <ReactHookFormIntlNumberInput
            append="%"
            control={control}
            disabled={disabled}
            fullWidth
            label={t('Dealer fee')}
            name={name}
            onBlur={({ value }) => handleOnBlurField({ name, setValue, value })}
        />
    );
};

DealerFee.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default DealerFee;
